import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { Content } from './content';

export const LightBox = ({ visible, showFreeShipping, staticUrl, baseUrl, onClose }) => (
    <Lightbox
        opened={visible}
        onClose={onClose}
        additionalClassNames={['catalog_delivery__lightbox']}
    >
        <Content
            showFreeShipping={showFreeShipping}
            onClose={onClose}
            staticUrl={staticUrl}
            baseUrl={baseUrl}
        />
    </Lightbox>
);

LightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    staticUrl: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};
